<div>
  <h2 *ngIf="header" class="small-h2" title="{{ header.merkmal }}">
    <div>
      <span>{{ header.merkmal }}</span>
      <sup *ngIf="header.hinweisTextMarkdown">
        <button type="button" class="btn-hint-ref"
          [attr.aria-label]="'components.dynamicSachverhalteForm.headerHint' | translate"
          (click)="scrollToHint('header')">
          [*]
        </button>
      </sup>
    </div>
    <small *ngIf="sachverhaltId || erfassungSachverhaltId" >
      ({{ 'components.dossier.sachverhaltId' | translate }}:
      {{ sachverhaltId ? sachverhaltId : erfassungSachverhaltId }})</small>
  </h2>
  <aside *ngIf="header?.hinweisTextMarkdown || fieldsWithHints.length > 0" class="hints-aside" [attr.aria-labelledby]="'hints-heading'">
    <h3 id="hints-heading" class="hints-heading">{{ 'components.dynamicSachverhalteForm.footnotesLabel' | translate }}</h3>
    <div *ngIf="header?.hinweisTextMarkdown" id="hint-header" class="hint-header" tabindex="-1" [markdown]="header.hinweisTextMarkdown"></div>
    <ol *ngIf="fieldsWithHints.length > 0" class="hint-list">
      <li *ngFor="let f of fieldsWithHints" [id]="'hint-' + f.key" tabindex="-1">
        <strong>{{ f.label }}</strong>
        <div [markdown]="f.hinweisTextMarkdown"></div>
      </li>
    </ol>
  </aside>
  <div *ngFor="let field of fields" class="form-group">
    <div *ngIf="field.type === 'subset'">
      <app-generic-item-list
        [idPrefix]="field.key"
        [data]="values[field.key] || []"
        [translations]="'components.dynamicSachverhalteForm.subsetValues' | translate"
        [translationParams]="{ label: field.label }"        
        [evenClass]="'subset-style-a'"
        [oddClass]="'subset-style-b'"
        [alwaysShowPlaceholder]="true"
        (append)="addWert(field.key, 'subset')"
        (remove)="deleteWert(field.key, $event.index)">
        <ng-template let-row let-rowIndex="index">
          <div *ngFor="let subsetField of field.fields" class="form-group">
            <ng-container *ngFor="let keySuffix of [field.key + '-' + rowIndex + '-' + subsetField.key]">
              <div class="uba-control-group">
                <label
                  [id]="'label-' + keySuffix"
                  [ngClass]="{ red: errorFields.has(keySuffix) }"
                  [for]="'field-' + keySuffix">
                  {{ subsetField.label }}
                  <span *ngIf="subsetField.required">*</span>
                  <sup *ngIf="subsetField.hinweisTextMarkdown">
                    <button type="button" class="btn-hint-ref"
                      [attr.aria-label]="'components.dynamicSachverhalteForm.footnoteRef' | translate : { index: getHintIndex(subsetField.key) }"
                      (click)="scrollToHint(subsetField.key)">
                      [{{ getHintIndex(subsetField.key) }}]
                    </button>
                  </sup>
                </label>
                <app-dynamic-control [field]="subsetField" [optionValues]="values[field.key][rowIndex]"
                  [value]="values[field.key][rowIndex][subsetField.key]"
                  [controlId]="'field-' + keySuffix"
                  [labelId]="'label-' + keySuffix"
                  (textValueChange)="onTextValueChange($event.value, $event.fieldKey, rowIndex, field.key)"
                  (rangeChanged)="onRangeChanged($event.value, $event.fieldKey, rowIndex, field.key)"
                  (intValueChange)="onIntValueChange($event.value, $event.fieldKey, rowIndex, field.key)"
                  (doubleValueChange)="onDoubleValueChange($event.value, $event.fieldKey, rowIndex, field.key)"
                  (dateChange)="onDateChange($event.value, $event.fieldKey, rowIndex, field.key)"
                  (dropdownValueChange)="onDropdownValueChange($event.value, $event.fieldKey, rowIndex, field.key)"
                  (fileLinkChanged)="onValueChanged($event.value, $event.fieldKey, rowIndex, field.key)">
                </app-dynamic-control>
              </div>
            </ng-container>
          </div>
        </ng-template>
      </app-generic-item-list>
    </div>

    <div *ngIf="field.type !== 'subset' && field.multiple" class="uba-control-group">
      <span [id]="'label-' + field.key" class="form-label" [ngClass]="{ red: errorFields.has(field.key) }">
        {{ field.label }}
        <span *ngIf="field.required">*</span>
        <sup *ngIf="field.hinweisTextMarkdown">
          <button type="button" class="btn-hint-ref"
            [attr.aria-label]="'components.dynamicSachverhalteForm.footnoteRef' | translate : { index: getHintIndex(field.key) }"
            (click)="scrollToHint(field.key)">
            [{{ getHintIndex(field.key) }}]
          </button>
        </sup>
      </span>

      <div class="uba-form-control">
        <app-generic-inline-item-list
          [idPrefix]="'field-' + field.key"
          [data]="values[field.key] || []"
          [translations]="'components.dynamicSachverhalteForm.multipleValues' | translate"
          [translationParams]="{ label: field.label }"
          (append)="addWert(field.key)"
          (remove)="deleteWert(field.key, $event.index)">
          <ng-template let-value let-i="index">
            <app-dynamic-control [field]="field" [optionValues]="values" [value]="value"
              [controlId]="'field-' + field.key + '-' + i"
              [describedById]="field.hinweisTextMarkdown ? 'hint-' + field.key : null"
              (textValueChange)="onTextValueChange($event.value, $event.fieldKey, i)"
              (rangeChanged)="onRangeChanged($event.value, $event.fieldKey, i)"
              (intValueChange)="onIntValueChange($event.value, $event.fieldKey, i)"
              (doubleValueChange)="onDoubleValueChange($event.value, $event.fieldKey, i)"
              (dateChange)="onDateChange($event.value, $event.fieldKey, i)"
              (dropdownValueChange)="onDropdownValueChange($event.value, $event.fieldKey, i)"
              (fileLinkChanged)="onValueChanged($event.value, $event.fieldKey, i)">
            </app-dynamic-control>
          </ng-template>
        </app-generic-inline-item-list>
      </div>
    </div>

    <div *ngIf="field.type !== 'subset' && !field.multiple" class="uba-control-group">
      <label [id]="'label-' + field.key" [ngClass]="{ red: errorFields.has(field.key) }"
        [for]="'field-' + field.key">
        {{ field.label }}
        <span *ngIf="field.required">*</span>
        <sup *ngIf="field.hinweisTextMarkdown">
          <button type="button" class="btn-hint-ref"
            [attr.aria-label]="'components.dynamicSachverhalteForm.footnoteRef' | translate : { index: getHintIndex(field.key) }"
            (click)="scrollToHint(field.key)">
            [{{ getHintIndex(field.key) }}]
          </button>
        </sup>
      </label>

      <app-dynamic-control *ngIf="!field.multiple" 
        class="uba-form-control"
        [field]="field" 
        [labelId]="'label-' + field.key"
        [describedById]="field.hinweisTextMarkdown ? 'hint-' + field.key : null"
        [optionValues]="values"
        [value]="values[field.key]" [controlId]="'field-' + field.key"
        (textValueChange)="onTextValueChange($event.value, $event.fieldKey)"
        (rangeChanged)="onRangeChanged($event.value, $event.fieldKey)"
        (intValueChange)="onIntValueChange($event.value, $event.fieldKey)"
        (doubleValueChange)="onDoubleValueChange($event.value, $event.fieldKey)"
        (dateChange)="onDateChange($event.value, $event.fieldKey)"
        (dropdownValueChange)="onDropdownValueChange($event.value, $event.fieldKey)"
        (fileLinkChanged)="onValueChanged($event.value, $event.fieldKey)">
      </app-dynamic-control>
    </div>
  </div>
</div>
<div *ngIf="serverValidationErrors.summary.length > 0">
  <div class="alert alert-danger" role="alert">
    <ul>
      <li *ngFor="let validationErrorText of serverValidationErrors.summary">
        {{ validationErrorText }}
      </li>
    </ul>
  </div>
</div>